import React from 'react';
import {
    Box,
    Card,
    CardContent,
    Typography,
    Grid,
    useTheme,
} from '@mui/material';
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    ResponsiveContainer
} from 'recharts';

// Кастомный тултип для BarChart динамики заказов
const CustomBarTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
        const day = payload[0].payload;
        return (
            <Box sx={{ p: 1, bgcolor: 'background.paper', color: 'text.primary', border: 1, borderColor: 'divider', borderRadius: 1 }}>
                <Typography variant="body2">Дата: {label}</Typography>
                <Typography variant="body2">Заказов: {day.count}</Typography>
                <Typography variant="body2">Общая сумма: {day.totalAmount?.toLocaleString() ?? '-'}</Typography>
                <Typography variant="body2">Чистая сумма: {day.baseAmount?.toLocaleString() ?? '-'}</Typography>
                <Typography variant="body2">Сумма по купонам: {day.cuponAmount?.toLocaleString() ?? '-'}</Typography>
            </Box>
        );
    }
    return null;
};

const OrderStats = ({ stats }) => {
    const theme = useTheme();
    const { ordersByStatus = [], dailyStats = [] } = stats || {};

    return (
        <Box sx={{ mb: 4 }}>
            <Grid container spacing={3}>
                <Grid item xs={12} sm={6} md={3}>
                    <Card>
                        <CardContent>
                            <Typography color="textSecondary" gutterBottom>
                                Всего заказов
                            </Typography>
                            <Typography variant="h4">{stats.totalOrders ?? '-'}</Typography>
                        </CardContent>
                    </Card>
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <Card>
                        <CardContent>
                            <Typography color="textSecondary" gutterBottom>
                                Сумма заказов
                            </Typography>
                            <Typography variant="h4">{stats.totalRevenue?.toLocaleString() ?? '-'}</Typography>
                        </CardContent>
                    </Card>
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <Card>
                        <CardContent>
                            <Typography color="textSecondary" gutterBottom>
                                Средний чек
                            </Typography>
                            <Typography variant="h4">{stats.avgOrderValue?.toLocaleString() ?? '-'}</Typography>
                        </CardContent>
                    </Card>
                </Grid>
                {ordersByStatus.map((stat) => (
                    <Grid item xs={12} sm={6} md={3} key={stat._id}>
                        <Card>
                            <CardContent>
                                <Typography color="textSecondary" gutterBottom>
                                    {stat._id === 'pending' && 'Ожидает оплаты'}
                                    {stat._id === 'paid' && 'Оплачено'}
                                    {stat._id === 'cancelled' && 'Отменено'}
                                </Typography>
                                <Typography variant="h4">
                                    {stat.count}
                                </Typography>
                                <Typography color="textSecondary">
                                    Сумма: {stat.totalAmount.toFixed(2)} ₽
                                </Typography>
                                <Typography color="textSecondary">
                                    Средний чек: {stat.averageAmount.toFixed(2)} ₽
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                ))}
            </Grid>
            <Box sx={{ mt: 4 }}>
                <Typography variant="h6" gutterBottom>Динамика заказов по дням</Typography>
                <ResponsiveContainer width="100%" height={250}>
                    <BarChart data={dailyStats}>
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="date" />
                        <YAxis />
                        <Tooltip content={CustomBarTooltip} />
                        <Bar dataKey="count" fill="#1976d2" />
                    </BarChart>
                </ResponsiveContainer>
            </Box>
        </Box>
    );
};

export default OrderStats;
